"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ICON_POSITION = exports.BUTTON_OPERATION = exports.BUTTON_FONT_FAMILY = exports.BUTTON_TYPE_HTML = exports.BUTTON_TARGET = exports.BUTTON_TYPE = exports.BUTTON_WIDTH = exports.BUTTON_HEIGHT = void 0;
/* eslint-disable import/extensions   */
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const next13_components_custom_link_1 = __importDefault(require("@gerenciatd/next13.components.custom-link"));
const spin_1 = __importDefault(require("./spin"));
const tools_1 = require("./tools");
const enums_js_1 = require("./enums.js");
Object.defineProperty(exports, "BUTTON_HEIGHT", { enumerable: true, get: function () { return enums_js_1.BUTTON_HEIGHT; } });
Object.defineProperty(exports, "BUTTON_WIDTH", { enumerable: true, get: function () { return enums_js_1.BUTTON_WIDTH; } });
Object.defineProperty(exports, "BUTTON_TYPE", { enumerable: true, get: function () { return enums_js_1.BUTTON_TYPE; } });
Object.defineProperty(exports, "BUTTON_TYPE_HTML", { enumerable: true, get: function () { return enums_js_1.BUTTON_TYPE_HTML; } });
Object.defineProperty(exports, "BUTTON_TARGET", { enumerable: true, get: function () { return enums_js_1.BUTTON_TARGET; } });
Object.defineProperty(exports, "BUTTON_FONT_FAMILY", { enumerable: true, get: function () { return enums_js_1.BUTTON_FONT_FAMILY; } });
Object.defineProperty(exports, "BUTTON_OPERATION", { enumerable: true, get: function () { return enums_js_1.BUTTON_OPERATION; } });
Object.defineProperty(exports, "ICON_POSITION", { enumerable: true, get: function () { return enums_js_1.ICON_POSITION; } });
const Button = ({ type, disabled, pill, fontFamily, forceExternal, width, height, Icon, iconProps, label, href, operation, segment, taggingInfo, onClick, target, buttonTypeHtml, className, cyData, }) => {
    if (onClick && !taggingInfo) {
        return null;
    }
    /* COMPLETING TAGGINGINFO IF NEEDED */
    if (onClick && taggingInfo) {
        if (!taggingInfo.componentContent) {
            // eslint-disable-next-line no-param-reassign
            taggingInfo.componentContent = label || "";
        }
        if (!taggingInfo.componentName) {
            // eslint-disable-next-line no-param-reassign
            taggingInfo.componentName = "Button";
        }
    }
    const { cssClassNames, buttonStyles } = (0, tools_1.composeCssClassNamesAndStyles)({
        segment,
        height,
        fontFamily,
        type,
        width,
        pill,
        disabled,
        className,
    });
    let iconPositionCss = null;
    if (Icon && iconProps && iconProps.position) {
        iconPositionCss = (0, tools_1.setIconPositionCss)(iconProps.position);
    }
    const operationIsVisible = operation && operation !== enums_js_1.BUTTON_OPERATION.NO;
    const labelAnimationCss = (0, tools_1.setLabelAnimation)(operation);
    return (react_1.default.createElement(next13_components_custom_link_1.default, { taggingInfo: taggingInfo, href: href, ariaLabel: label, onClick: onClick, style: buttonStyles, buttonTypeHtml: buttonTypeHtml, forceExternal: forceExternal, buttonParent: true, className: cssClassNames, target: target, disabled: disabled, cyData: cyData },
        !operationIsVisible &&
            Icon &&
            (iconProps.width || iconProps.height) &&
            iconProps.position && (react_1.default.createElement("div", { className: `layout-icon ${iconPositionCss || iconProps.position}`, id: "button-textWithIcon" },
            react_1.default.createElement("span", { className: "button-textArea" }, label),
            react_1.default.createElement(Icon, Object.assign({}, iconProps, { className: "button-iconArea" })))),
        !operationIsVisible && !Icon && (react_1.default.createElement("span", { id: "button-textWithoutIcon" }, label)),
        operationIsVisible && (react_1.default.createElement("div", { className: `${labelAnimationCss}`, id: "button-operation" },
            react_1.default.createElement(spin_1.default, { operation: operation, spinType: type })))));
};
Button.propTypes = {
    /**
     * Información para el tagueado del componente.
     */
    taggingInfo: prop_types_1.default.object.isRequired,
    /**
     * Tema del botón.
     */
    type: prop_types_1.default.string,
    /**
     * Añade la clase css 'pill-shape' para que el botón posea 'border-radious'.
     */
    pill: prop_types_1.default.bool,
    /**
     * Permite definir si el botón está desactivado o no; en caso de desactivado el elemento cambiará de color y dejará de ser clicable.
     */
    disabled: prop_types_1.default.bool,
    /**
     * Tipo de fuente del texto, por defecto es regular.
     */
    fontFamily: prop_types_1.default.string,
    /**
     * Función js que se ejecutará al hacer click, si es necesario.
     */
    onClick: prop_types_1.default.func,
    /**
     * Url a la que se accederá tras hacer click en el elemento si es que lo tuviese.
     */
    href: prop_types_1.default.string,
    /**
     * Valor del target en caso de tener link.
     */
    target: prop_types_1.default.string,
    /**
     * Define si el enlace se tiene que forzar a comportar como enlace externo.
     */
    forceExternal: prop_types_1.default.bool,
    /**
     * Define el ancho del botón.
     */
    width: prop_types_1.default.string,
    /**
     * Altura del botón.
     */
    height: prop_types_1.default.string,
    /**
     * Componente icono ya renderizado.
     */
    Icon: prop_types_1.default.oneOfType([prop_types_1.default.node, prop_types_1.default.func]),
    /**
     * Posicion del icono respecto al texto del botón.
     */
    iconProps: prop_types_1.default.object,
    /**
     * Texto que aparecerá dentro del componente.
     */
    label: prop_types_1.default.string,
    /**
     * Permite establecer una animación en función de un estado a este componente, reflejando una operación de las definidas BUTTON_OPERATION.
     */
    operation: prop_types_1.default.string,
    /**
     * Valor del tipo de button.
     */
    buttonTypeHtml: prop_types_1.default.string,
    /**
     * Define la clase CSS custom que se aplicará al componente.
     */
    className: prop_types_1.default.string,
    cyData: prop_types_1.default.string,
};
Button.defaultProps = {
    pill: false,
    type: enums_js_1.BUTTON_TYPE.PRIMARY,
    className: "",
    disabled: false,
    fontFamily: enums_js_1.BUTTON_FONT_FAMILY.REGULAR,
    width: "default",
    height: enums_js_1.BUTTON_HEIGHT.NORMAL,
    Icon: null,
    iconProps: {
        position: enums_js_1.ICON_POSITION.RIGHT,
    },
    label: "",
    operation: enums_js_1.BUTTON_OPERATION.NO,
    onClick: null,
    target: "_self",
    buttonTypeHtml: enums_js_1.BUTTON_TYPE_HTML.BUTTON,
    forceExternal: false,
    href: "",
    cyData: "",
};
exports.default = Button;
//# sourceMappingURL=index.js.map